<template>
  <div class="keyboard">
    <div class="kb-row" v-for="(row, idx) in layout" :key="idx">
      <button
        v-for="key in row"
        :key="key"
        class="kb-key"
        :class="keyClass(key)"
        :disabled="disabled"
        @click="onClick(key)"
      >
        <span v-if="key === 'ENTER'">⏎</span>
        <span v-else-if="key === 'BACK'">⌫</span>
        <span v-else>{{ key }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Keyboard",
  props: {
    solution: { type: String, required: true },
    keyboardState: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      layout: [
        ["A", "Z", "E", "R", "T", "Y", "U", "I", "O", "P"],
        ["Q", "S", "D", "F", "G", "H", "J", "K", "L", "M"],
        ["BACK", "W", "X", "C", "V", "B", "N", "ENTER"],
      ],
    };
  },
  methods: {
    onClick(key) {
      if (this.disabled) return;
      this.$emit("key", key);
    },
    keyClass(key) {
      if (key === "ENTER" || key === "BACK") {
        return "action";
      }
      const st = this.keyboardState[key];
      if (st === "correct") return "correct";
      if (st === "present") return "present";
      if (st === "absent") return "absent";
      if (st === "given") return "given";
      return "neutral";
    },
  },
};
</script>

<style scoped>
.keyboard {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 544px; /* cohérent avec la board / top-bar */
  padding: 0 8px;
  box-sizing: border-box;
}

.kb-row {
  display: flex;
  margin-bottom: 10px;
  width: 100%;
  justify-content: center;
}


/* --- Touche de base --- */
.kb-key {
  flex: 1 1 0;          /* <= chaque touche prend une part de la ligne */
  max-width: 46px;      /* <= taille max sur desktop */
  height: 64px;
  margin: 4px;
  padding: 0;
  border-radius: 10px;
  border: 2px solid #ffffff;
  background: var(--kb-empty);
  color: #ffffff;
  cursor: pointer;
  font-weight: 700;
  font-size: 18px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.05s ease, filter 0.1s ease;
  touch-action: manipulation;
}


/* --- Hover léger pour touches neutres --- */
.kb-key:not(.correct):not(.present):not(.absent):not(.action):hover {
  filter: brightness(1.2); /* ✨ mini surbrillance */
  transform: translateY(-1px);
}

/* --- Rouge (correct) --- */
.kb-key.correct {
  background: var(--kb-correct);
  border-color: var(--kb-correct);
  /* box-shadow: 0 5px 0 rgba(0, 0, 0, 0.4); */
  border: 2px solid #ffffff;
}

/* --- Jaune (present) --- */
.kb-key.present {
  background: var(--kb-present);
  border-color: var(--kb-present);
  color: #ffffff;
  /* box-shadow: 0 5px 0 rgba(0, 0, 0, 0.4); */
  border: 2px solid #ffffff;
}

/* --- Absent (neutral + fade) --- */
.kb-key.absent {
  background: var(--kb-empty);
  border-color: #ffffff;
  opacity: 0.35;
}

/* --- BACK / ENTER --- */
.kb-key.action {
  flex: 1.3 1 0;
  max-width: 70px;
  height: 54px;
  background: #ffffff;
  border-color: #ffffff;
  color: #154153;
  font-weight: 900;
}


/* --- Responsive --- */
@media (max-width: 720px) {
  .kb-key {
    max-width: 40px;
    height: 48px;
    font-size: 15px;
    margin: 3px;
  }

  .kb-key.action {
    max-width: 56px;
    height: 44px;
  }
}

/* encore plus petit (type 320px) */
@media (max-width: 400px) {
  .keyboard {
    padding: 0 4px;
  }

  .kb-key {
    max-width: 34px;
    height: 42px;
    font-size: 13px;
    margin: 2px;
  }

  .kb-key.action {
    max-width: 50px;
    height: 40px;
  }
}

</style>
